import React, { forwardRef } from 'react';
import {
  AutoComplete as AntdAutoComplete,
  AutoCompleteProps as AntdAutoCompleteProps,
} from 'antd';
import type { RefSelectProps } from 'antd/es/select';
import classNames from 'classnames';

import styles from './autocomplete.module.scss';

export type AutoCompleteProps = AntdAutoCompleteProps;
export type AutoCompleteRef = RefSelectProps;

export const AutoComplete = forwardRef<AutoCompleteRef, AutoCompleteProps>(
  ({ className, ...props }, ref) => {
    return (
      <AntdAutoComplete
        className={classNames(styles['the5ersAutocomplete'], className)}
        ref={ref}
        {...props}
      />
    );
  },
);
